import React, { useEffect, useState } from "react";
import { DatePicker, Flex, Modal, Select } from "antd";
import { Button, Form, Input } from "antd";
import { getMonth, getYear, isBefore, startOfToday } from "date-fns";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { List, Typography } from "antd";
import { format } from "date-fns";
import TextArea from "antd/es/input/TextArea";
import { BASE_API_URL } from "../../../utils/consts";
import dayjs from "dayjs";
const { Option } = Select;

const { Text } = Typography;
type Props = {
  isOpen: boolean;
  onCloseModal: () => void;
  mode?: "create" | "edit";
  locations: any;
  clientId: any;
  onUpdate: () => void;
  positionInSectorData: any;
  workSectors: any;
};

const PositionInSector: React.FC<Props> = ({
  isOpen,
  onCloseModal,
  locations,
  mode = "create",
  clientId,
  onUpdate,
  positionInSectorData,
  workSectors,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [activeLocation, setActiveWorkSector] = useState<any>(undefined);

  const handleOk = () => {
    onCloseModal();
    form.resetFields();
  };

  //   useEffect(() => {
  //     if (isOpen) {
  //       form.setFieldsValue({
  //         date: dayjs(), // današnji datum
  //       });
  //     }
  //   }, [isOpen, form]);

  useEffect(() => {
    if (isOpen) {
      if (mode === "edit" && positionInSectorData) {
        form.setFieldsValue({
          workSector: positionInSectorData.workSector.name || "",
          positionName: positionInSectorData.name,
          //   location: workSectorData.locationId || undefined,
          //   notes: workSectorData.notes || "",
        });
      } else {
        form.resetFields();
        form.setFieldsValue({
          date: dayjs(), // današnji datum
        });
      }
    }
  }, [isOpen, mode, positionInSectorData, form]);

  const handleCancel = () => {
    onCloseModal();
    form.resetFields();
  };
  const onFinish = async (values: any) => {
    if (mode === "create") {
      axios
        .post(`${BASE_API_URL}/admin/${clientId}/createPosition`, {
          workSector: activeLocation.value,
          name: values.positionName,
          notes: values.notes,
          clientId: clientId,
        })
        .then(() => {
          onUpdate();
        });
    } else if (mode === "edit" && positionInSectorData?._id) {
      await axios.put(
        `${BASE_API_URL}/admin/${clientId}/updatePosition/${positionInSectorData._id}`,
        {
          workSector:
            activeLocation?.value || positionInSectorData.workSector._id,
          name: values.positionName,
          notes: values.notes,
          clientId,
        }
      );
    }
    onCloseModal();
  };

  useEffect(() => {}, []);

  const disabledPast = (current: any) => {
    return current && isBefore(current.toDate(), startOfToday());
  };

  console.log("workSectors, workSectors", workSectors);
  return (
    <Modal
      title={<div className="">{t("Add Sector Position")}</div>}
      open={isOpen}
      onOk={handleOk}
      className="standardHeader"
      onCancel={handleCancel}
      footer={[]}
    >
      <Form
        name="fixedPaymentForm"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="workSector"
          label={t("Work Sector")}
          rules={[{ required: true, message: "Please select sector!" }]}
        >
          <Select
            placeholder={t("Select sector")}
            onChange={(value, data) => setActiveWorkSector(data)}
            //   allowClear
            value={""}
          >
            {workSectors?.map((item: any, index: number) => {
              return (
                <Option value={item._id} key={index}>
                  {item.name} - {item?.location?.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label={t("Position name")}
          name="positionName"
          rules={[{ required: true, message: t("Position name required") }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t("Notes")}
          name="notes"
          rules={[{ required: false, message: t("Please enter notes") }]}
        >
          <TextArea rows={2} />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Flex gap="small" wrap="wrap">
            <Button type="primary" htmlType="submit">
              {t("Save")}
            </Button>
            {/* {mode !== "create" && (
              <Button danger onClick={handleCancel}>
                {t("Delete")}
              </Button>
            )} */}
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PositionInSector;
